/**
 * @fileOverview Rugby data parser. Makes use of common parsers wherever
 * possible.
 */
import gamePackage      from './gamePackage'
import clubhouse        from './clubhouse/index'

export { gamePackage }
export { clubhouse }

export default {
  gamePackage,
  clubhouse
}



/** WEBPACK FOOTER **
 ** ../app/lib/transform/parsers/rugby/index.js
 **/